import { ExarePriceDetailsPriceElementType } from '@websky/graphql';
export const isFareElement = (price) => price.type === ExarePriceDetailsPriceElementType.fare;
export const isTaxesAgency = (price) => price.type === ExarePriceDetailsPriceElementType.taxesAgency && 'taxCode' in price && !!price.taxCode;
export const isTaxesRetention = (price) => price.type === ExarePriceDetailsPriceElementType.taxesRetention && 'taxCode' in price && !!price.taxCode;
